/**
 * staff
 */
export default ((cmp, util) => {
	// 登録・編集ボタン
	$('.item-edit-btn').each(function() { cmp.modal(this); });

	// 削除ボタン
	$('.item-delete-btn').each(function() { cmp.modal(this); });

	// 右から出るモーダル監視とイベント
	const saveStaff = function() {
		// 保存ボタン
		$('#save-btn').click(function() {
			util.checkSession();
			cmp.messageDone('保存しています');
			var fd = new FormData($(this).closest('form').get(0));

			$.ajax({
				type: "POST",
				url: $(this).closest('form').attr('action'),
				dataType: 'json',
				timeout: 20000,
				data: fd,
				processData: false,
				contentType: false
			}).done(function (data) {
				if(data.message) cmp.messageError(data.message);
				if(data.error) {
					cmp.messageCaution(data.error);
					return false;
				}

				cmp.messageDone('', true); // close
				if(data.reload) location.reload();
				return false;

			}).fail(function (jqXHR, textStatus, errorThrown) {
				console.log("jqXHR: " + jqXHR.status); // HTTPステータスが取得
				console.log("textStatus: " + textStatus); // タイムアウト、パースエラー
				console.log("errorThrown: " + errorThrown.message); // 例外情報
				util.checkSession(jqXHR);
			});
		});
	};
	const modalSeObs = util.observer($('#js-modal--white__body').get(0), function() {
		saveStaff();
		cmp.selectBox('select[name="authority"],select[name="readable_organization_id"], select[name="readable_shop_id"]');
	});
	const modalSdObs = util.observer($('#js-modal__body').get(0), function() {
		saveStaff();
	});
});
